<template>
  <div class="container-fluid">
    <div class="row">
      <div class="opening-client">
        <h1>Shake !!</h1>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Shake from "shake.js/shake";
export default {
  name: "openingClient",
  data() {
    return {};
  },
  mounted() {
    // listen to shake event
    var shakeEvent = new Shake({ threshold: 10 });
    shakeEvent.start();
    window.addEventListener(
      "shake",
      () => {
        firebase
          .database()
          .ref("opening")
          .push()
          .set({
            value: 0
          });
      },
      false
    );

    //check if shake is supported or not.
    if (!("ondevicemotion" in window)) {
      alert("Not Supported");
    }
  },
  methods: {
    //stop listening
    stopShake() {
      shakeEvent.stop();
    }
    // },
    // gameStart() {
    //   this.startGame = true
    // }
  }
};
</script>

<style lang="scss" scoped>
.opening-client {
  background: #240b36;
  color: #fff;
  width: 100vw;
  height: 100vh;
  animation-name: loopShakeBG;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  text-align: center;
}

.opening-client > h1 {
  animation-name: loopShakeText;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  text-align: center;
  line-height: 90vh;
}

@keyframes loopShakeBG {
  from {
    background: #8e1625;
  }
  to {
    background: #240b36;
  }
}

@keyframes loopShakeText {
  from {
    font-size: 50px;
  }
  to {
    font-size: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/opening/openingClient.vue